<template>
  <van-popup 
    class="phone-verify-code-popup"
    v-model:show="showPopup"
    :close-on-click-overlay="true"
    position="bottom"
    @click.self="onPopupClick($event)"
  >
    <div class="popup-content">
      <div class="title-text">
        验证手机号
      </div>
      <div class="phone-text">
        {{ phone }}
      </div>
      <div class="verify-input">
        <input 
          class="input-item"
          type="tel"
          placeholder="输入6位验证码"
          v-model="code"
          @input="onChange($event)"
          @click.stop
        />
        <div class="verify-wrap">
          <span
            v-if="count > 0" 
            class="count-text"
          >{{ count }}秒后重新获取</span>
          <span
            v-if="count <= 0" 
            class="count-text"
            :class="{'loading': isSendVerify}"
            @click="sendVerifyCode()"
          >
            <van-loading class="loading-spin" v-if="isSendVerify" size="18px"></van-loading>
            获取验证码</span>
        </div>
      </div>
      <div class="error-text" v-if="isError">
        验证码错误，请检查后重试
      </div>
      <div class="submit-button" :class="{'disabled': code.length < 6}" @click="okHandle()">完成验证并提交</div>
      <div class="tips-text">
        完成验证码验证后即可提交您的信息。如需更换手机号，请关闭此弹框，并在当前表单中做修改。
      </div>
    </div>
  </van-popup>
</template>

<script>
import { api } from "@/utils/fetch.js";
import { Popup, Toast, Loading } from "vant";
import { checkPhoneHasSame } from '@/utils/helper.js';
import _ from 'lodash';

export default {
  props: {
  },
  emits: ['ok'],
  data() {
    return {
      showPopup: false,
      isSendVerify: false,
      isSubmit: false,
      isError: false,
      phone: '',
      row: {},
      code: '',
      count: 0,
    };
  },
  components: {
    [Popup.name]: Popup,
    [Loading.name]: Loading
  },
  methods: {
    onPopupClick(e) {
      this.showPopup = false;

    },
    open(phone, row) {
      this.phone = phone;
      this.row = _.cloneDeep(row);
      this.showPopup = true;
    },
    onChange(e) {
      const len = 6;
      if(this.code?.toString()?.length > len) {
        const str = this.code?.toString().slice(0, len);
        this.code = str;
      }
    },
    countDown() {
      clearTimeout(this.countTimer);
      this.countTimer = setTimeout(() => {
        this.count --;
        if (this.count > 0) {
          this.countDown();
        }
      }, 1000);
    },
    sendVerifyCode() {
      if (this.isSendVerify) {
        return;
      }

      const body = {
        mobile: this.phone
      }
      this.isSendVerify = true;
      api.SendVerifyCode(body).then((res) => {
        this.count = res?.retry_after_seconds || 60;
        this.countDown();
        Toast('发送验证码成功');
      })
      .catch((e) => {
      })
      .finally(() => {
        this.isSendVerify = false;
      });
    },
    async okHandle() {
      if (this.isSubmit) {
        return;
      }
      if (this.row?.unique) {
        const hasSamePhone = await checkPhoneHasSame(this.phone, this.row);
        if (hasSamePhone) {
          Toast('已存在该手机号的提交记录');
          return;
        }
      }

      const body = {
        mobile: this.phone,
        code: this.code
      };
      this.isSubmit = true;
      api.Verify(body).then((res) => {
        if (res === 'ok') {
          Toast('验证成功');
          this.showPopup = false;
          this.isError = false;
          this.$emit('ok', this.code);
        } else {
          Toast('验证错误');
          this.isError = true;
        }
      })
      .catch((e) => {
        this.isError = true;
      })
      .finally(() => {
        this.isSubmit = false;
      });
    }
  },
  created() {},
  async mounted() {
  },
};
</script>

<style lang="less">
@import (reference) '@/assets/less/common.less';

.phone-verify-code-popup {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;

  .popup-content {
    background-color: #fff;
    padding: 24px;
    border-radius: 4px;
    width: 90%;
    box-sizing: border-box;
    text-align: center;

    .title-text {
      font-size: @font-size-4;
      line-height: 18px;
      color: @desc-color-2;
      margin-bottom: 9px;
      font-weight: 400;
    }
    .phone-text {
      font-weight: 700;
      font-size: 20px;
      line-height: 18px;
      margin-bottom: 24px;
      color: @title-color;
    }
    .error-text {
      font-size: @font-size-4;
      line-height: 18px;
      color: #D61313;
      text-align: left;
      margin-top: 8px;
    }
    .tips-text {
      font-size: @font-size-4;
      line-height: 18px;
      color: @desc-color-2;
      text-align: left;
    }

    .verify-input {
      position: relative;
      .input-item {
        .input-item();
      }
      .verify-wrap {
        line-height: 43px;
        height: 43px;
        padding-right: 18px;
        position: absolute;
        right: 0px;
        bottom: 0px;
        .count-text {
          color: var(--theme-main-color);
          font-size: @font-size-2;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          &.loading {
            color: #8c8c8c;
          }
          .loading-spin {
            margin-right: 4px;
          }
        }
      }
    }
    .submit-button {
      .submit-button();
      margin-top: 14px;
      margin-bottom: 12px;
    }
  }
}

</style>
